import { useState } from 'react';
import { Container, Typography, Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, Card, CardContent, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { loadData, saveData, uid } from '../store/data';
import SectionHero from '../components/SectionHero';
import { motion } from 'framer-motion';

export default function Categories() {
  const [data, setData] = useState(loadData());
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ id: '', name: '', description: '' });

  const openAdd = () => {
    setEditing(null);
    setForm({ id: '', name: '', description: '' });
    setOpen(true);
  };
  const openEdit = (item) => {
    setEditing(item.id);
    setForm(item);
    setOpen(true);
  };
  const close = () => setOpen(false);

  const save = () => {
    let categories = data.categories || [];
    if (editing) {
      categories = categories.map((i) => (i.id === editing ? form : i));
    } else {
      categories = [...categories, { ...form, id: uid() }];
    }
    const next = { ...data, categories };
    saveData(next);
    setData(next);
    setOpen(false);
  };

  const remove = (id) => {
    const categories = (data.categories || []).filter((i) => i.id !== id);
    const subcategories = (data.subcategories || []).filter((s) => s.categoryId !== id);
    const products = (data.products || []).filter((p) => p.categoryId !== id);
    const next = { ...data, categories, subcategories, products };
    saveData(next);
    setData(next);
  };

  const items = data.categories || [];

  return (
    <>
      <SectionHero
        title="Product Categories"
        subtitle="Define main lines to organize your racking portfolio"
        variant="grid"
      />
      <Container sx={{ py: { xs: 4, md: 6 }, px: { xs: 2, sm: 3 } }}>
        <Box sx={{ display: 'flex', justifyContent: { xs: 'stretch', sm: 'flex-end' }, mb: 2 }}>
          <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd} fullWidth sx={{ maxWidth: { sm: 'none' }, width: { xs: '100%', sm: 'auto' } }}>Add Category</Button>
        </Box>
      <Grid container spacing={3} component={motion.div} initial="hidden" animate="show" variants={{ hidden: {}, show: { transition: { staggerChildren: 0.08 }}}}>
        {items.map((it) => (
          <Grid item xs={12} md={6} key={it.id} component={motion.div} variants={{ hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0 }}}>
            <Card component={motion.div} whileHover={{ y: -4 }} transition={{ type: 'spring', stiffness: 300, damping: 22 }}>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1, flexWrap: 'wrap' }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, minWidth: 0, wordBreak: 'break-word' }}>{it.name}</Typography>
                  <Box>
                    <IconButton onClick={() => openEdit(it)}><EditIcon /></IconButton>
                    <IconButton onClick={() => remove(it.id)}><DeleteIcon /></IconButton>
                  </Box>
                </Box>
                <Typography sx={{ color: 'text.secondary', mt: 1 }}>{it.description}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
        <DialogTitle>{editing ? 'Edit Category' : 'Add Category'}</DialogTitle>
        <DialogContent sx={{ display: 'grid', gap: 2 }}>
          <TextField label="Name" fullWidth value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <TextField label="Description" fullWidth multiline rows={4} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
        </DialogContent>
        <DialogActions>
          <Button onClick={close}>Cancel</Button>
          <Button variant="contained" onClick={save}>Save</Button>
        </DialogActions>
      </Dialog>
    </Container>
    </>
  );
}
